export default __webpack_public_path__ + "static/media/editIcon.d0b3d847.svg";